__turbopack_context__.v({
  "container": "gt_JzG_container",
});
